
import './OneCard.scss';
import {ReactNode} from "react";

interface IOneCard{
    title:ReactNode;
    content:ReactNode;
}
export default function OneCard(props:IOneCard){
    return (
        <div className="one-card swiper-one">
            <div className="title">{props.title}</div>
            <div className="content">
                <div className={'left-decorator'}/>
                <div className="real-content">{props.content}</div>

            </div>
        </div>
    )
}
